/** Percent positions for scan twinkle dots until API provides real coordinates. */
const SCAN_PLACEHOLDER_REGIONS: { top: number; left: number }[] = [
  { top: 14, left: 50 },
  { top: 32, left: 24 },
  { top: 36, left: 76 },
  { top: 52, left: 32 },
  { top: 55, left: 70 },
  { top: 72, left: 50 },
  { top: 24, left: 72 },
  { top: 80, left: 22 },
];

const PERSONA_REGION_OFFSET: Record<string, number> = {
  site_safety: 0,
  workmanship: 1,
  analyze: 2,
  execute: 3,
  review: 4,
};

export const ANALYZE_OVERLAY_PERSONA_GLOW: Record<string, string> = {
  site_safety: "rgba(239, 68, 68, 0.35)",
  workmanship: "rgba(249, 115, 22, 0.35)",
  analyze: "rgba(56, 189, 248, 0.35)",
  execute: "rgba(52, 211, 153, 0.35)",
  review: "rgba(167, 139, 250, 0.35)",
};

export const ANALYZE_OVERLAY_PERSONA_RING: Record<string, string> = {
  site_safety: "rgba(248, 113, 113, 0.9)",
  workmanship: "rgba(251, 146, 60, 0.9)",
  analyze: "rgba(56, 189, 248, 0.9)",
  execute: "rgba(52, 211, 153, 0.9)",
  review: "rgba(167, 139, 250, 0.9)",
};

/** Pulsing placeholder dots while a run is in flight. */
export function getScanPlaceholderPins(personaId: string): { top: number; left: number }[] {
  const offset = PERSONA_REGION_OFFSET[personaId] ?? 0;
  return [0, 1, 2].map((i) => SCAN_PLACEHOLDER_REGIONS[(i + offset) % SCAN_PLACEHOLDER_REGIONS.length]);
}

export const analyzeIdsSignature = (ids: string[]) => [...ids].sort().join(",");

export function getPersonaOverlayColors(personaId: string | null | undefined) {
  const glowColor =
    (personaId && ANALYZE_OVERLAY_PERSONA_GLOW[personaId]) || "hsl(var(--primary) / 0.25)";
  const ringColor =
    (personaId && ANALYZE_OVERLAY_PERSONA_RING[personaId]) || "hsl(var(--primary))";
  return { glowColor, ringColor };
}
